import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { useSendPushNotification } from "@/hooks/mutations/use-send-push-notification";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "../ui/alert-dialog";

export function ConfirmSendNotification({
	open,
	close,
	mode,
}: {
	open: boolean;
	close: () => void;
	mode: "test" | "prod";
}) {
	const params = useParams();
	const { mutate } = useSendPushNotification();

	function handleSendNotification() {
		if (!params || !params.id) {
			toast("Unable to send push without notification id");
			return;
		}

		mutate(
			{
				isProd: mode === "prod",
				notificationId: params.id,
			},
			{
				onError: () => {
					close();
					toast("Unable to send push notification");
				},
				onSuccess: () => {
					close();
					toast("Push notification sent, please check your device");
				},
			},
		);
	}

	return (
		<AlertDialog open={open}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>
						[{mode.toUpperCase()}] Are you absolutely sure?
					</AlertDialogTitle>
					<AlertDialogDescription>
						You are about to send this push notification to all registered{" "}
						{mode.toUpperCase()} users. Please confirm your decision.
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel onClick={close}>Cancel</AlertDialogCancel>
					<AlertDialogAction onClick={handleSendNotification}>
						Continue
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
